"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 定制省市区组件
 * ** 重要
 * 必须在 targetForm 对象预留 PCD字段（用于form表单校验报错）
 * 必须传入省市区 6个key name，没有也要传
 * 外部数据保存的时候，PCD字段如果有必要，自行 delete targetForm.PCD
 */
var _default2 = exports.default = {
  name: 'FormCascaderBySR',
  props: {
    // 层级
    level: {
      type: String,
      default: 'sr'
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 挂载省市区字段的对象
    targetForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 省市区6字段的key
    keyList: {
      type: Array,
      default: function _default() {
        return ['region', 'regionCode', 'city', 'cityCode', 'district', 'districtCode'];
      }
    },
    // 返回的省市区是否要为数组regionCodeList/cityCodeList/districtCodeList
    returnArray: false,
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    },
    // 插件props配置
    regionProps: {
      type: Object,
      default: function _default() {
        return {
          expandTrigger: 'hover'
        };
      }
    },
    regionData: {
      type: Object,
      default: function _default() {
        return {
          'province': '',
          'provinceCode': '',
          'city': '',
          'cityCode': '',
          'district': '',
          'districtCode': ''
        };
      }
    },
    targetForm2: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      regionOptions: [] // 省市区
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    placeholderTxt: function placeholderTxt() {
      var txt = this.placeholder || this.$t('common.pleaseSelect');
      return this.isDisabled ? '' : txt;
    }
  },
  mounted: function mounted() {
    this.fetchRegionList(); // 省市区
  },
  methods: {
    /** 省市区 enum */fetchRegionList: function fetchRegionList() {
      var _this = this;
      // const regionOptions = this.$store.getters.getRegionData(`level_${this.level}`)
      // if (Array.isArray(regionOptions) && regionOptions.length) {
      //   this.regionOptions = regionOptions
      //   return
      // }
      this.$api.common.getSRRegionList(this.regionData).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this.regionOptions = responseData.data || [];
          _this.$store.dispatch('baseData/saveRegionDataBySR', {
            key: "level_".concat(_this.level),
            regionData: responseData.data || []
          });
          console.log('-===this.regionData==', _this.regionData);
          if (_this.regionData.provinceCode) {
            var pcd = [];
            var keys = _this.keyList || [];
            _this.setVal(keys[0], _this.regionData.province);
            _this.setVal(keys[1], _this.regionData.provinceCode);
            pcd.push(_this.regionData.provinceCode);
            if (_this.regionData.cityCode) {
              _this.setVal(keys[2], _this.regionData.city);
              _this.setVal(keys[3], _this.regionData.cityCode);
              pcd.push(_this.regionData.cityCode);
              if (_this.regionData.districtCode) {
                _this.setVal(keys[4], _this.regionData.district);
                _this.setVal(keys[5], _this.regionData.districtCode);
                pcd.push(_this.regionData.districtCode);
              }
            }
            console.log('-===pcd==', pcd);
            _this.setVal('PCD', pcd); // 省
          } else {
            var _keys = _this.keyList || [];
            _this.setVal(_keys[0], _this.regionOptions[0]['label']); // 省label
            _this.setVal(_keys[1], _this.regionOptions[0]['value']); // 省
            _this.setVal('PCD', [_this.regionOptions[0]['value']]); // 省
          }
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    /** 省市区选中 */onRegionChange: function onRegionChange() {
      var _this2 = this;
      // console.log(1111, this.keyList)
      this.$nextTick(function () {
        if (!_this2.$refs['region']) {
          console.log('还没初始化完成');
          return false;
        }
        var nodes = _this2.$refs['region'].getCheckedNodes();
        var node = nodes[0] || {};
        var _node$path = node.path,
          path = _node$path === void 0 ? [] : _node$path,
          _node$pathLabels = node.pathLabels,
          pathLabels = _node$pathLabels === void 0 ? [] : _node$pathLabels;
        console.log(path);
        // console.log(2222, path, pathLabels)
        var keys = _this2.keyList || [];
        _this2.setVal(keys[0], pathLabels[0]); // 省label
        _this2.setVal(keys[1], _this2.returnArray && path[0] ? [path[0]] : path[0]); // 省
        _this2.setVal(keys[2], pathLabels[1]); // 市label
        _this2.setVal(keys[3], _this2.returnArray && path[1] ? [path[1]] : path[1]); // 市
        _this2.setVal(keys[4], pathLabels[2]); // 区label
        _this2.setVal(keys[5], _this2.returnArray && path[2] ? [path[2]] : path[2]); // 区
      });
    },
    // 获取数据
    getVal: function getVal(key) {
      if (this.targetForm && key) {
        return this.targetForm[key] || '';
      } else {
        return '';
      }
    },
    // 外部数据赋值
    setVal: function setVal(key, val) {
      if (this.targetForm) {
        if (key) {
          this.targetForm[key] = val;
        }
      }
    }
  }
};